document.addEventListener("DOMContentLoaded", () => {
  const now = new Date();

  const scheduleWrapper = document.querySelector('.schedule_registration');
  if (!scheduleWrapper) return;

  /**
   * end パラメーターをローカル時刻として Date 化する。
   * 対応形式：
   * - end=2026-02-03              → 2026/02/03 23:59:59 まで有効
   * - end=2026-02-03T18:00        → 2026/02/03 18:00 まで有効
   * - end=2026-02-03%2018:00      → 2026/02/03 18:00 まで有効
   * - end=2026-02-03_18-00        → 2026/02/03 18:00 まで有効
   */
  const parseEndDateTime = (value) => {
    if (!value) return null;

    const decoded = decodeURIComponent(value).replace(/\+/g, ' ').trim();
    const match = decoded.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[T\s_](\d{1,2})(?::|-)?(\d{2}))?$/);
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const hasTime = match[4] !== undefined;
    const hour = hasTime ? Number(match[4]) : 23;
    const minute = hasTime ? Number(match[5]) : 59;
    const second = hasTime ? 0 : 59;
    const millisecond = hasTime ? 0 : 999;

    return new Date(year, month, day, hour, minute, second, millisecond);
  };

  const getEndParam = (href) => {
    if (!href) return null;

    try {
      const url = new URL(href, window.location.origin);
      return url.searchParams.get('end');
    } catch (error) {
      const match = href.match(/[?&]end=([^&#]+)/);
      return match ? match[1] : null;
    }
  };

  const disableButton = (cta, link) => {
    const btnText = link.querySelector('.btn_text');

    if (btnText) {
      btnText.textContent = "終了";
      btnText.style.backgroundColor = "#b7b7b7";
      btnText.style.backgroundImage = "none";
    }

    link.setAttribute('href', 'javascript:void(0)');
    link.style.cursor = 'default';
    link.style.pointerEvents = 'none';

    cta.style.backgroundImage = "none";
    cta.style.cursor = "default";
  };

  const ctaButtons = scheduleWrapper.querySelectorAll('.cta_btn');

  ctaButtons.forEach(cta => {
    const link = cta.querySelector('a.btn');
    if (!link) return;

    const href = link.getAttribute('href');
    const endAt = parseEndDateTime(getEndParam(href));

    if (endAt && now >= endAt) {
      disableButton(cta, link);
    }
  });
});
